// lbl.home
export const home = {
    welcome_bk: "Welcome to BK",
    start_app: "Start Application",
    welcome_burgerking: "Welcome to Burgerking",
};
